import { SessionStorageService } from 'app/core/services/session-storage.service';
import { PaginatedListState } from 'app/shared/states/paginated-list-state';
import { cloneDeep } from 'lodash-es';

export class PreviewState extends PaginatedListState {
  public static defaultSortInvoice = 'number_asc';
  public static defaultSortProForma = 'createDate_asc';
  public static maxUuidsLengthFromURL = 175;
  public numberId: string;
  public sort: string;
  public strKeyLocalStoragePageSize: string;
  public uuids: string[] | null | undefined;

  public constructor() {
    super();
    this.resetFilter();
  }

  public static loadStateFromURL(
    previewState: PreviewState,
    uuidsFromUrl: string,
    numberIdFromUrl: string | null,
    uuidFromUrl: string | null = null,
  ): PreviewState {
    if (!previewState) {
      previewState = new PreviewState();
    }

    if (numberIdFromUrl) {
      previewState.numberId = numberIdFromUrl;
    }

    if (uuidsFromUrl) {
      const state = SessionStorageService.deserializeJson<PreviewState>(uuidsFromUrl);
      if (state) {
        previewState = cloneDeep(state);
      }
    }

    if (uuidFromUrl) {
      previewState.uuids = [uuidFromUrl];
    }

    return previewState;
  }

  public isFilterSetToDefaultValues(): boolean {
    if (!this.pageIndex || this.pageIndex === 0) {
      return true;
    }

    if ((!this.pageIndex || this.pageIndex === 0) && this.isSortSetToDefaultValues()) {
      return true;
    }

    return false;
  }

  public resetFilter(): void {
    this.pageIndex = 0;
    this.uuids = [];
  }
}
